<template>
    <div @click.prevent="$emit('clicked')" class="relative w-full px-2 py-[5px] overflow-hidden rounded-full" :class="backgroundColor">
        <div class="absolute inset-0 z-0" :class="accentBackgroundColor" :style="`width: ${durationRangePercentage}%;`"></div>
        <p class="relative z-10 text-xs font-medium text-center whitespace-nowrap" :class="textColor">{{ text }}</p>
    </div>
</template>

<script>
    import DateRangeDaysDuration from '~spa/classes/DateRangeDaysDuration';

    export default {
        props: {
            startDate: {
                type: String,
                required: true
            },
            endDate: {
                type: String,
                required: true
            },
            backgroundColor: {
                type: String,
                default: 'bg-gray-400'
            },
            accentBackgroundColor: {
                type: String,
                default: 'bg-primary'
            },
            textColor: {
                type: String,
                default: 'text-white'
            },
            dateFormat: {
                type: String,
                default: 'DD MMM YYYY'
            },
            customText: {
                type: String,
                required: false,
            }
        },
        computed: {
            durationRangePercentage()
            {
                return new DateRangeDaysDuration(this.startDate, this.endDate).getPercentage();
            },
            text()
            {
                if ( this.customText ) {
                    return this.customText;
                }

                if ( window.moment(this.startDate).isSame(this.endDate, 'day') ) {
                    return window.moment(this.startDate).format(this.dateFormat);
                }

                return window.moment(this.startDate).format(this.dateFormat) + ' - ' + window.moment(this.endDate).format(this.dateFormat)
            }
        }
    }
</script>
